module.exports = __webpack_public_path__ + "img/switchOff.png?e0adc75029f70476fac9bb9d041af0a1";